import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import {
  gray02,
  gray05,
  primary,
  white,
} from 'presentations/views/styles/color';
import Image from 'presentations/views/components/atoms/Image';
import Link from 'presentations/views/components/atoms/Link';
import Icon from 'presentations/views/components/atoms/Icon';
import {
  borderRadius,
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import styled from '@emotion/styled';
import ServiceSubSectionTitle from 'presentations/views/components/molecules/ServiceSubSectionTitle';

export default function Component() {
  const t = translateInComponent(translations);
  return (
    <>
      <SubSectionTitle title={t('payment title')} icon={'payment'} />
      <Card>
        <PaymentList>
          <PaymentListItem>
            <PaymentListItemTitle>{t('payment 1 title')}</PaymentListItemTitle>
            <PaymentListItemContent>
              <PaymentListItemNumberContainer>
                <PaymentListItemNumber>
                  {t('payment_1_commission.0')}
                  <PaymentListItemNumberSuffix>
                    {t('payment_1_commission.1')}
                  </PaymentListItemNumberSuffix>
                </PaymentListItemNumber>
              </PaymentListItemNumberContainer>
              <PaymentListItemFeeDescription>
                {t('payment_1_commission description')}
              </PaymentListItemFeeDescription>
              <PaymentServiceList>
                <PaymentServiceLink
                  href="https://stripe.com/jp/pricing"
                  target="_blank"
                  rel="noopener"
                >
                  <PaymentServiceListItem
                    dpr={2}
                    src="pages/integrations/stripe.svg"
                    alt="visa"
                    width={48}
                  />
                  <IconWrap name="open-in-new" />
                </PaymentServiceLink>
              </PaymentServiceList>
              <PaymentListItemDescription>
                {t('payment 1 description')}
              </PaymentListItemDescription>
              <PaymentCardList>
                <PaymentCardListItem
                  dpr={2}
                  src="credit_cards/visa.png"
                  alt="visa"
                  width={36}
                  height={24}
                />
                <PaymentCardListItem
                  dpr={2}
                  src="credit_cards/master.png"
                  alt="master"
                  width={36}
                  height={24}
                />
                <PaymentCardListItem
                  dpr={2}
                  src="credit_cards/jcb.png"
                  alt="jcb"
                  width={36}
                  height={24}
                />
                <PaymentCardListItem
                  dpr={2}
                  src="credit_cards/amex.png"
                  alt="amex"
                  width={36}
                  height={24}
                />
                <PaymentCardListItem
                  dpr={2}
                  src="credit_cards/diners.png"
                  alt="diners"
                  width={36}
                  height={24}
                />
                <PaymentCardListItem
                  dpr={2}
                  src="credit_cards/discover.png"
                  alt="discover"
                  width={36}
                  height={24}
                />
              </PaymentCardList>
              {/* <CampaignImageContainer>
                <Link href="/resources/campaign/payment-campaign">
                  <CampaignImage
                    src="campaigns/payment_202112.png"
                    width={400}
                    height={242}
                    dpr={2}
                    alt={''}
                  />
                </Link>
              </CampaignImageContainer> */}
            </PaymentListItemContent>
          </PaymentListItem>
          <PaymentListItem>
            <PaymentListItemTitle>{t('payment 2 title')}</PaymentListItemTitle>
            <PaymentListItemContent>
              <PaymentListItemNumber>
                {t('payment 2 commission')}
              </PaymentListItemNumber>
              <PaymentListItemDescription>
                {t('payment 2 description')}
              </PaymentListItemDescription>
            </PaymentListItemContent>
          </PaymentListItem>
        </PaymentList>
      </Card>
    </>
  );
}

const PaymentList = styled.div`
  padding: 0 ${spacing(40)};
`;
const PaymentListItem = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${gray05};
  padding-bottom: ${spacing(20)};
  margin-bottom: ${spacing(20)};
  :last-of-type {
    border-bottom: 0;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  ${mediaMax.tablet} {
    display: block;
  }
`;
const PaymentListItemTitle = styled.div`
  width: 180px;
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(24)};
`;
const PaymentListItemContent = styled.div`
  flex: 1;
`;
const PaymentListItemDescription = styled.div`
  margin-top: ${spacing(8)};
`;
const PaymentListItemNumberContainer = styled.div`
  display: flex;
  align-items: baseline;
`;
const PaymentListItemNumber = styled.div`
  color: ${primary};
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(20)};
  display: flex;
  align-items: center;
`;
const PaymentListItemNumberSuffix = styled.span`
  font-size: ${fontSize(13)};
  margin-right: ${spacing(2)};
`;
const PaymentListItemFeeDescription = styled.div`
  margin-top: ${spacing(8)};
`;
const SubSectionTitle = styled(ServiceSubSectionTitle)`
  margin-bottom: ${spacing(32)};
`;
const Card = styled.div`
  box-shadow: 0px 10px 30px rgba(102, 102, 102, 0.15);
  border-radius: ${borderRadius(16)};
  padding: ${spacing(32)} 0;
  background-color: ${white};
  margin-right: ${spacing(32)};
  :last-of-type {
    margin-right: 0;
  }
`;

const PaymentCardList = styled.div`
  margin-top: ${spacing(16)};
  ${mediaMax.tablet} {
    margin-top: 0;
  }
`;
const PaymentCardListItem = styled(Image)`
  margin-right: ${spacing(8)};
  :last-of-type {
    margin-right: 0;
  }
  ${mediaMax.tablet} {
    margin-top: ${spacing(8)};
  }
`;

const PaymentServiceList = styled.div`
  margin: ${spacing(16)} 0;
  ${mediaMax.tablet} {
    margin-top: 0;
  }
`;
const PaymentServiceListItem = styled(Image)`
  margin-right: ${spacing(8)};
  :last-of-type {
    margin-right: 0;
  }
  ${mediaMax.tablet} {
    margin-top: ${spacing(8)};
  }
`;

const PaymentServiceLink = styled(Link)`
  display: flex;
  align-items: center;
`;
const IconWrap = styled(Icon)`
  width: 18px !important;
  height: 18px !important;
  color: ${gray02};
`;
